/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Out_Reason_AdjustmentInputs */

const vi_aml_out_reason_adjustment = /** @type {(inputs: Aml_Out_Reason_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh`)
};

/**

* @param {Aml_Out_Reason_AdjustmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_out_reason_adjustment = /** @type {((inputs?: Aml_Out_Reason_AdjustmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Out_Reason_AdjustmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_out_reason_adjustment(inputs)
});